import { render, staticRenderFns } from "./Item15.vue?vue&type=template&id=33d46f7d&"
import script from "./Item15.vue?vue&type=script&lang=js&"
export * from "./Item15.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports